import TransferForm from '../model/form.model';
import CustomerProduct from '../../../../shared/models/customer-product.model';
import Product from '../../../../shared/models/product.model';
import { BaseController } from '@shared/basecontroller.controller';

class FormController extends BaseController {
  constructor(PeerToPeerStore, FormService, AppService, $timeout) {
    'ngInject';

    super(AppService);

    this.PeerToPeerStore = PeerToPeerStore;
    this.FormService = FormService;
    this.$timeout = $timeout;

    this.transactionSummary = {
      fromProduct: null,
      toProducts: [],
    };
  }

  $onInit() {
    // Combines two observables
    this.detailsSubscription = this.PeerToPeerStore.getDetails().subscribe((details) => {
      this.form = new TransferForm(details.products, details.customerProducts);
    });
    this.session = this.getSession();

    this.userCurrency$ = this.PeerToPeerStore.getCurrency();

    this.$timeout(() => {
      $(".gateway-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".gateway-sidebar-wrap").toggleClass('active');
      });
    }, 500);
  }

  $onDestory() {
    this.detailsSubscription.unsubscribe();
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }

  submit() {
    this.FormService.isSubmitting.next(true);
    this.PeerToPeerStore.p2pTransfer(this.form.toPayload())
    .then(() => {
      this.form.hasError = false;
      this.onSuccessfulSubmission();
    })
    .catch(errors => this.form.error.setFormErrors(errors))
    .finally(() => this.FormService.isSubmitting.next(false))
    ;
  }

  createTransactionSummary() {
    const fromProduct = this.form.customerProducts.filter((item) => {
      return item.id === this.form.fromProduct;
    })[0];

    if (fromProduct) {
      this.transactionSummary.fromProduct = `${fromProduct.product.name} (${fromProduct.username})`;
    }

    const productsSelected = this.form.subTransactions.map((item) => {
      return item.code;
    });

    this.transactionSummary.toProducts = this.form.products
      .filter((item) => {
        return productsSelected.indexOf(item.code) > -1;
      })
      .map((item, idx) => {
        return `${item.username} (${this.form.subTransactions[idx].username})`;
      });
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/component/form.controller.js